import React from 'react';
import { styled, css } from 'styled-components';
import { createTransition } from '../../util';
import { StateLayer } from '../StateLayer';
import { Icon } from '../../components/Icon';
import { Text } from '../../components/Text';
const baseToggleStyles = css(["position:relative;display:block;box-sizing:border-box;overflow:hidden;width:1.25rem;height:1.25rem;flex-shrink:0;margin-right:var(--aui-spacing-100);", ""], ({
  $showInteraction
}) => $showInteraction && css(["&:before,[data-aui='icon'],", "{", "}", " &:has(~ input:focus-visible){outline:1px solid blue;}&:has(~ input:disabled){opacity:var(--aui-state-layer-on-disabled);}"], StateLayer, createTransition({
  properties: ['opacity']
}), createTransition({
  properties: ['box-shadow', 'background-color', 'color']
})));
const StyledCheckbox = styled.span.withConfig({
  componentId: "aui__sc-sebr06-0"
})(["", ";border-radius:var(--aui-border-radius-050);", " [data-aui='icon']{position:absolute;opacity:", ";}"], baseToggleStyles, ({
  $checked
}) => $checked ? css(["box-shadow:0 0 0 1px var(--aui-inverse-surface) inset;background:var(--aui-inverse-surface);color:var(--aui-inverse-on-surface);"]) : css(["box-shadow:0 0 0 1px var(--aui-outline) inset;background:var(--aui-surface);color:var(--aui-on-surface);"]), ({
  $checked
}) => $checked ? '1' : '0');
const StyledRadio = styled.span.withConfig({
  componentId: "aui__sc-sebr06-1"
})(["", ";border-radius:var(--aui-border-radius-round);background:var(--aui-surface);", " &:before{content:'';position:absolute;border-radius:var(--aui-border-radius-round);width:0.625rem;height:0.625rem;top:0.3125rem;left:0.3125rem;background:var(--aui-inverse-surface);opacity:", ";}"], baseToggleStyles, ({
  $checked
}) => $checked ? css(["box-shadow:0 0 0 2px var(--aui-inverse-surface) inset;"]) : css(["box-shadow:0 0 0 1px var(--aui-outline) inset;"]), ({
  $checked
}) => $checked ? '1' : '0');
export const CheckboxToggle = props => /*#__PURE__*/React.createElement(StyledCheckbox, props, /*#__PURE__*/React.createElement(StateLayer, null), /*#__PURE__*/React.createElement(Icon.SSR, {
  "aria-hidden": "true",
  src: "checkmark-v",
  size: "medium"
}));
export const RadioToggle = props => /*#__PURE__*/React.createElement(StyledRadio, props, /*#__PURE__*/React.createElement(StateLayer, null));
export const StyledDescription = styled(Text).attrs({
  size: 2
}).withConfig({
  componentId: "aui__sc-sebr06-2"
})(["color:var(--aui-on-surface);line-height:1.3;&:has(~ input:disabled){opacity:var(--aui-state-layer-on-disabled);cursor:not-allowed;}"]);
export const HiddenInput = styled.input.withConfig({
  componentId: "aui__sc-sebr06-3"
})(["position:fixed;opacity:0;pointer-events:none;"]);

/** Add this style snippet to the label containing this ToggleCore component */
export const toggleParentStyles = css(["&:not(:has(input:disabled)){&:hover ", " ", ",&:hover ", " ", "{opacity:var(--aui-state-layer-hover);}&:active ", " ", ",&:hover ", " ", "{opacity:var(--aui-state-layer-press);}}"], StyledCheckbox, StateLayer, StyledRadio, StateLayer, StyledCheckbox, StateLayer, StyledRadio, StateLayer);